import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const OrganizationhistoryApi = createApi({
  reducerPath: "OrganizationhistoryApi",
  baseQuery,
  tagTypes: ["Organizationhistory"],
  endpoints: (builder) => ({
    getHistory: builder.query({
      query: ({ id }) => {
        console.log("📢 History API Called With ID:", id);  // <-- 🌟 console added
        return `/customers/history/${id}`;
      },

      transformResponse: (response) => {
        console.log("📦 Raw History API Response:", response); // <-- 🌟 log added
        
        const data = response?.data ?? [];
        console.log("📦 Raw History API data:", data); // <-- 🌟 log added
        const normalized = Array.isArray(data) ? data : [data];
        console.log("📦 Raw History API normalized:", normalized); // <-- 🌟 log added

        return normalized.map((item) => ({
          ...item,
          id: item.customerHistoryId,
        }));
      },

      providesTags: ["Organizationhistory"],
    }),
  }),
});

export const {
  useLazyGetHistoryQuery,
} = OrganizationhistoryApi;   // <-- FIXED (correct variable)
